const  AllProjects=[ 
     {
         id:18,
        title:"natural",
        technology:"WordPress, Elementor, Polylang, WPForms, Custom Menus",
        description:"Developed a bilingual WordPress site (Arabic & English) for natural skincare products using Elementor and Polylang.",
        linkDemo:"https://naturalproduct.kesug.com/en/home/",
        

        
    },
    {
         id:17,
        title:"Gym Management System",
        technology:"Nuxt,TailwindCss,MongoDB,Nodejs",
        description:"A Gym Management System to easily add and manage trainees and trainers, track attendance using barcode scanning, and display membership status with alerts for upcoming or expired subscriptions.",
        linkDemo:"https://gym-managment-zclb.vercel.app",
        linkGithup:"https://github.com/weamibrahim/GymManagment",

        
    }
    ,
    {
        id:16,
        title:"Furniture",
        technology:"Angular,Bootstrap,Postgresql,Django",
        description:"The website provides Furniture you can show it , The owner of the Furniture is the only one who can create new Furniture, update it , delete it.",
        linkDemo:"https://furniture-7ba7f.web.app",
        linkGithup:"https://github.com/weamibrahim/Furniture",



    },
    {
        id:15,
        title:"PharmaClinic",
        technology:"React,Tailwind,mongodb,node js",
        description:"A web-based medical management system where Admins manage users, Doctors manage patients and prescriptions, and Pharmacists dispense medications and receive real-time prescription updates. Built-in chat allows seamless communication between users.",
        linkDemo:"https://pharma-clinic.vercel.app",
        linkGithup:"https://github.com/weamibrahim/PharmaClinic",



    }, 
    {
        id:14,
        title:"Online Food Ordering",
        technology:"React,TailwindCSS,mongodb,nodejs",
        description:"The website where users can browse, order, and pay securely, while admins manage foods, orders, and users via an intuitive dashboard ",
        linkDemo:"https://food-delivery-fg8n.vercel.app/",
        linkGithup:"https://github.com/weamibrahim/FoodDelivery",


    },
    
    {
        id:13,
        title:"ChatApp",
        technology:"vue js,bootStrap,mongodb,node js",
        description:"The chat application allows users to register, log in, search for other users, and engage in real-time conversations. It provides a seamless messaging experience and includes a password recovery feature.",
        linkDemo:"https://chat-app-2cap.vercel.app/",
        linkGithup:"https://github.com/weamibrahim/chatApp",



    },
    
    {
        id:12,
        title:"TourManagment",
        technology:"React,bootstrap,mongodb,node js",
        description:"The website provides Tours you can show it , show reviews,make reviews and   booking on it , the admin is the only create the tour , update it and delete it ,show all tours ,show all reviews and all users",
        linkDemo:"https://tour-managment-euug.vercel.app/",
        linkGithup:"https://github.com/weamibrahim/TourManagment",



    },
    {
        id:11,
        title:"posts",
        technology:"Angular , Graphql, bootstrap,mongodb,node js",
        description:"The website provides posts you can show it and comments on it, The owner of the post is the only one who can edit it , delete it and delete comments on it",
        linkDemo:"https://posts-1b588.web.app",
        linkGithup:"https://github.com/weamibrahim/Posts",



    },
    {
        id:10,
        title:"narrative",
        technology:"Next js ,  TailwindCss ,Mongodb",
        description:"website that allows admin to add ,edit , and delete novels ,  and allow user to login and show novels and read it .",
        linkDemo:"https://narrative-gamma.vercel.app/",
        linkGithup:"https://github.com/weamibrahim/narrative",



    }, {
        id:9,
        title:"personal budget",
        technology:" React , html , Css , Bootstrap",
        description:"website that allows users to add, edit, and delete income and expense records, and display a summary of their financial activity.",
        linkDemo:"https://personal-budget-aaa9e.web.app/",
        linkGithup:"https://github.com/weamibrahim/Personal-Budget",
  
        


    }, {
        id:8,
        title:"your drink",
        technology:" Vue Js,Nodejs , Mongodb",
        description:"Built an e-commerce website for drinks. Features include user sign-up/log-in, adding items to cart, viewing detailed product information, and checkout/payment with credit card.",
        linkDemo:"https://your-drink.vercel.app/",
        linkGithup:"https://github.com/weamibrahim/your_drink",



    }, {
        id:7,
        title:"order your cake",
        technology:"Vue js, laravel,mysql ,Vue js",
        description:"Built an e-commerce website for cakes. Features include user sign-up/log-in, adding items to cart, viewing detailed product information, and checkout/payment with credit card.",
        linkDemo:"",
        linkGithup:"https://github.com/weamibrahim/order_your_cake",



    }, {
        id:6,
        title:"My flower",
        technology:"React,Node.js ,Mongodb",
        description:"Built an e-commerce website for Flowers. Features include user sign-up/log-in, adding items to cart, viewing detailed product information, and checkout/payment with credit card.",
        linkDemo:"https://flowershop-7326f.web.app",
        linkGithup:"https://github.com/weamibrahim/flower-shop",



    }, {
        id:5,
        title:"plate-palate",
        technology:"Node.js, Angular, MongoDB(ITI Team Project)",
        description:"Plate Palate: E-Commerce hub for global food purchase & recipe exploration, catering to culinary enthusiasts seeking diverse flavors & convenience.",
        linkDemo:"https://drive.google.com/file/d/1g7WKr6sZmiqvWtb447FDgjJvpbSU0jaP/view?usp=drivesdk ",
        linkGithup:"https://github.com/orabi55555/plate-palate",



    }, {
        id:4,
        title:"From-Home-To-Home",
        technology:"Node.js, Angular, MongoDB(ITI Team Project)",
        description:"website that acts as a middleman between home cooks selling homemade food and customers ordering homemade meals. The platform will include ratings and reviews.",
        linkDemo:"",
        linkGithup:"https://github.com/YousefAdel2020/From-Home-To-Home",



    }, {
        id:3,
        title:"Articles Managements System",
        technology:"PHP (ITI Team Project)",
        description:"The website enables user authentication and role-based access control for managing articles. Features include user login, group management, user management, and article creation with restrictions on editing.",
        linkDemo:"https://user-images.githubusercontent.com/112786733/236077335-acb942e3-25a2-414d-b6e4-508c252e9fe5.mp4",
        linkGithup:"https://github.com/weamibrahim/Article_PHP_Project",



    },
    {
        id:2,
        title:"Pharmacy Management System",
        technology:"Laravel (ITI Team Project)",
        description:"Admin: Full control, CRUD for system entities, Laravel Sanctum auth,Pharmacy/Doctor: Manage orders, CRUD for doctors, revenue tracking,User : Register, login, order management, scheduled notifications.",
        linkDemo:"",
        linkGithup:"https://github.com/asmaagamal871/Laravel-project",



    },
    {
        id:1,
        title:"E-Commerce Web Application",
        technology:"HTM,CSS,Javascript(ITI Team Project)",
        description:"Built an e-commerce website for watches and glasses.Utilized LocalStorage for item data storage.Features include user sign-up/log-in,adding items to cart/favorites,viewing detailed product information,and checkout/payment with credit card.",
        linkDemo:"https://www.loom.com/share/7a378db81cfa4d03bee4dcf33faeb78e",
        linkGithup:"https://github.com/MaysaraSafwat/JS-Frontend",



    },
   

]
export default AllProjects
